import { queryClient } from 'api/reactQuery';
import { accountsQueryKeys } from './hooks';

/**
 * Forgets where an account stands against its providers' limits.
 *
 * The answer is held for minutes rather than re-asked per page, so the events that actually move
 * the count have to say so. Cancelling is the one that matters most: the explanation modal tells
 * the commuter to cancel a booking to free a slot, and they would otherwise come back to a Book
 * button still refusing them.
 *
 * Invalidated by account rather than per plan, because one booking changes the answer for every
 * plan of that provider — including plans in answers that never mentioned the booked one. Without
 * an account, every account's answers go, which is what a caller that cannot name one should get.
 */
export const invalidateBookingLimits = (accountId?: string | null) => queryClient.invalidateQueries({
  queryKey: accountId ? accountsQueryKeys.getBookingLimits(accountId) : accountsQueryKeys.allBookingLimits()
});